module.exports = __webpack_public_path__ + "static/img/info2.9137798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/info2.png
// module id = JL3E
// module chunks = 1